import UserManager from "./Auth/UserManager";

const UserUtils = {
  getFistName: () => {
    const user = UserManager.getUser();
    const phisicalPeople = user && user.type === "F";
    if (user !== null)
      return phisicalPeople
        ? user?.basicInfo?.firstName
        : user?.companyInfo?.companyFantasyName;
    return "";
  },
  getLastName: () => {
    const user = UserManager.getUser();
    const phisicalPeople = user && user.type === "F";
    if (user !== null)
      return phisicalPeople
        ? user?.basicInfo?.lastName
        : user?.companyInfo?.companyFantasyName;
    return "";
  },
  getEmail: () => {
    const user = UserManager.getUser();
    const phisicalPeople = user && user.type === "F";
    if (user !== null)
      return phisicalPeople
        ? user.basicInfo.email.address
        : user.companyInfo.contactInfo.email;
    return "";
  },
  getSecretNumber: (number) => {
    if (number !== "" && number !== undefined) {
      let n = number.replace("-", "");
      n = `${number[0]}XXXX-${number.slice(5, 9)}`;
      return n;
    }
    return "";
  },
};

export default UserUtils;
